// extracted by mini-css-extract-plugin
module.exports = {"BatchRequestsTable":"_3oU3tbig","batchRequestContent":"pxO2edZK","declineContent":"_1xmUvpW0","batchRequestHeader":"rlXpr4kJ","candidateHeaderLeft":"_3beVf0ee","batchRequestHeaderBold":"AQj0Q5zF","batchRequestHeaderText":"_1JOgSDXt","dateContent":"_1qPmXvpf","sendEmailContent":"_3MkMLym7","nameHeader":"_2i8AjR_G","dateHeader":"_3IK1oJlZ","declineHeader":"_2awFmxnG"};
    if(module.hot) {
      // 1746735834057
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  